export default {
	album: {},
	list: []
};



// WEBPACK FOOTER //
// ./sources/app/gallery/state.js